/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "./SliderNavigation.module.scss";
import { Icon } from "../../../components/Icons/Icons";

const SliderNavigation = ({
	swiperRefLoaded,
	swiperRef,
	navigationClasses,
	slidesPerPage,
	totalSlides,
}) => {
	const [currentIndex, setCurrentIndex] = useState(0);

	useEffect(() => {
		if (swiperRefLoaded && swiperRef.current) {
			swiperRef.current.on("slideChange", () => {
				setCurrentIndex(swiperRef?.current?.realIndex ?? 0);
			});
		}
	}, [swiperRefLoaded, swiperRef]);

	const handlePrevSlide = () => {
		if (currentIndex + slidesPerPage >= totalSlides) {
			if (totalSlides % slidesPerPage === 0) {
				swiperRef.current.slideTo(currentIndex - slidesPerPage);
			} else {
				swiperRef.current.slideTo(currentIndex - (totalSlides % slidesPerPage));
			}
		} else {
			swiperRef.current.slideTo(currentIndex - slidesPerPage);
		}
	};

	const handleNextSlide = () => {
		swiperRef.current.slideTo(currentIndex + slidesPerPage);
	};

	return (
		<>
			<button
				className={cx(
					navigationClasses?.prevButton,
					styles.button,
					styles.buttonPrev,
					navigationClasses?.button,
					{
						"swiper-button-disabled": currentIndex === 0,
					}
				)}
				type="button"
				onClick={handlePrevSlide}
				disabled={currentIndex === 0}>
				<Icon name="arrow-left" />
			</button>
			<button
				className={cx(
					navigationClasses?.nextButton,
					styles.button,
					styles.buttonNext,
					navigationClasses?.button,
					{
						"swiper-button-disabled": currentIndex + slidesPerPage >= totalSlides,
					}
				)}
				type="button"
				onClick={handleNextSlide}
				disabled={currentIndex + slidesPerPage >= totalSlides}>
				<Icon name="arrow-right" />
			</button>
		</>
	);
};

SliderNavigation.propTypes = {
	swiperRefLoaded: PropTypes.bool.isRequired,
	swiperRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
	navigationClasses: PropTypes.shape({
		button: PropTypes.string,
		prevButton: PropTypes.string,
		nextButton: PropTypes.string,
	}).isRequired,
	slidesPerPage: PropTypes.number.isRequired,
	totalSlides: PropTypes.number.isRequired,
};

export default SliderNavigation;
export { SliderNavigation };
